import { APPEND_TO } from '../PopoverNext/PopoverNext.constants';
import { ValuesOf } from '../utils/typeUtils';

export const PLACEMENT = {
  top: 'top',
  bottom: 'bottom',
  right: 'right',
  left: 'left',
} as const;

export const TEXT_SIZES = {
  small: 'small',
  medium: 'medium',
} as const;

export type PopoverMenuPlacement = ValuesOf<typeof PLACEMENT>;
export type PopoverMenuAppendTo = ValuesOf<typeof APPEND_TO>;
export type PopoverMenuTextSize = ValuesOf<typeof TEXT_SIZES>;
